import axios from 'axios'
// import { baseUrl } from './env'


const axiosIns = axios.create({
  // baseURL: baseUrl
  // timeout: 30000
})

axiosIns.interceptors.request.use(config => {
  if (process.env.NODE_ENV === 'production') {
    if (config.url.includes('/apis')) {
      config.url = config.url.replace('/apis', '')
    }
    if (config.url.includes('/operApi')) {
      config.url = config.url.replace('/operApi', 'https://operation.uopgenjoy.com')
    }
  }
  //配置config
  if ((config.method === 'post' || config.method === "put") && !config.url.includes('/admin/file/public/upload')) {
    config.headers = {
      'Content-Type': 'application/json;charset=utf-8',
      // 'Authorization': 'Bearer e301eeb8-db10-4bdd-9965-6d1e1d061f39'
    }
  } else {
    config.headers = {
      'Content-Type': 'multipart/form-data'
    }
  }
  return config
}, error => {
  return Promise.reject(error)
})

axiosIns.interceptors.response.use(response => {
  if (response.status !== 200) {
    return Promise.reject({msg: "网络连接错误", data: response})
  } else {
    let res = response.data
    if (res.code !== 0) {
      return Promise.reject(res)
    } else {
      return Promise.resolve(res.data)
    }
  }
}, error => {
  let response = error && error.response
  let data = response ? response.data : { msg: '出错了，请重试', data: null }
  return Promise.reject(data)
})

export default {
  get(uri, params = {}) {
    return axiosIns.get(uri, { params })
  },
  post(uri, params = {}) {
    return axiosIns.post(uri, params)
  }
}